import MiniSearch from 'minisearch';
import type { DatasetType } from '../types/QueryTypes';
const REQUEST_SEARCH_FIELDS = ['acc_name', 'req_name', 'req_products', 'req_sub_region', 'opp_region', 'user_sc_name', 'req_status'];
const TOUCHPOINT_SEARCH_FIELDS = ['acc_name', 'tp_name', 'tp_type', 'tp_solution_comments', 'opp_market_area', 'opp_region', 'user_sc_name', 'tp_status'];
const SEARCH_OPTIONS = {
  fuzzy: 0.2,
  prefix: true
};
export class SearchIndex {
  private requestIndex: MiniSearch | null = null;
  private touchpointIndex: MiniSearch | null = null;
  buildRequestIndex(data: Record<string, unknown>[]): void {
    this.requestIndex = new MiniSearch({
      fields: REQUEST_SEARCH_FIELDS,
      idField: 'req_id',
      searchOptions: SEARCH_OPTIONS
    });
    const seen = new Set<string>();
    const unique = data.filter(r => {
      const id = String(r.req_id);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
    this.requestIndex.addAll(unique as never[]);
  }
  buildTouchpointIndex(data: Record<string, unknown>[]): void {
    this.touchpointIndex = new MiniSearch({
      fields: TOUCHPOINT_SEARCH_FIELDS,
      idField: 'tp_id',
      searchOptions: SEARCH_OPTIONS
    });
    const seen = new Set<string>();
    const unique = data.filter(r => {
      const id = String(r.tp_id);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
    this.touchpointIndex.addAll(unique as never[]);
  }
  search(query: string, dataset: DatasetType): Set<string> {
    const results = new Set<string>();
    if ((dataset === 'request' || dataset === 'both') && this.requestIndex) {
      const hits = this.requestIndex.search(query);
      for (const hit of hits) {
        results.add(String(hit.id));
      }
    }
    if ((dataset === 'touchpoint' || dataset === 'both') && this.touchpointIndex) {
      const hits = this.touchpointIndex.search(query);
      for (const hit of hits) {
        results.add(String(hit.id));
      }
    }
    return results;
  }
  isReady(): boolean {
    return this.requestIndex !== null || this.touchpointIndex !== null;
  }
}
let globalIndex: SearchIndex | null = null;
export function getSearchIndex(): SearchIndex {
  if (!globalIndex) {
    globalIndex = new SearchIndex();
  }
  return globalIndex;
}
export function buildSearchIndex(requestData: Record<string, unknown>[], touchpointData: Record<string, unknown>[]): SearchIndex {
  const index = getSearchIndex();
  index.buildRequestIndex(requestData);
  index.buildTouchpointIndex(touchpointData);
  return index;
}